import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { debounceTime, fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BusinessesService } from '../../../services/businesses.service';
import { EventEmitterService } from '../../../services/event-emitter.service';
import { BusinessPopupComponent } from '../../../modals/business-popup/business-popup.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeletePopupComponent } from '../../../modals/delete-popup/delete-popup.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-businesses',
  templateUrl: './businesses.component.html',
  styleUrl: './businesses.component.scss',
})
export class BusinessesComponent implements OnInit, AfterViewInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  search = '';
  businesses = [];
  page = 1;
  pageSize = 10;
  totalItems = 0;
  totalPages = 1;
  loading = false;
  destoryRef = inject(DestroyRef);

  constructor(
    private businessesService: BusinessesService,
    private modalService: BsModalService,
    public eventEmitterService: EventEmitterService,
    private translateService: TranslateService,
  ) {
    this.eventEmitterService.invokeEvent
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((event) => {
        if (event == 'call-all-businesses') {
          this.resetPagination();
          this.getAllBusinesses();
        }
      });
  }

  ngOnInit() {
    this.resetPagination();
    this.getAllBusinesses();
  }

  ngAfterViewInit(): void {
    this.setupSearch();
  }

  resetPagination() {
    this.businesses = [];
    this.page = 1;
    this.pageSize = 10;
    this.totalItems = 0;
    this.totalPages = 1;
  }

  getAllBusinesses() {
    if (this.loading) {
      return;
    }
    this.loading = true;

    const apiData: any = {
      page: this.page,
      pageSize: this.pageSize,
    };

    if (this.search && this.search.trim().length > 0) {
      apiData.search = this.search;
    }
    this.businessesService.getAllBusinesses(apiData).subscribe(
      (response: any) => {
        this.loading = false;

        this.businesses = response.items;
        this.page = response.page;
        this.pageSize = response.pageSize;
        this.totalItems = response.totalItems;
        this.totalPages = response.totalPages;

        this.businesses.forEach((item) => {
          const options = [];

          if (item.payment_options.includes('pay-on-delivery')) {
            options.push(this.translateService.instant('pay-on-delivery'));
          }

          if (item.payment_options.includes('pay-with-credit-card')) {
            options.push(this.translateService.instant('pay-with-credit-card'));
          }

          item.paymentOptionsString = options.join(', ');

          item.bannerURL = item.banners[0].bannerURL;
        });
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.loading = false;
      },
    );
  }

  setupSearch() {
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(debounceTime(3000))
      .subscribe((event: Event) => {
        this.resetPagination();
        this.getAllBusinesses();
      });
  }

  setSearch(event: any) {
    this.search = event.target.value;
  }

  onPageChange(event: { page: number; pageSize: number }) {
    this.page = event.page;
    this.pageSize = event.pageSize;
    this.getAllBusinesses();
  }

  addBusiness() {
    this.modalService.show(BusinessPopupComponent, {
      initialState: {
        title: 'new-business',
        type: 'new-business',
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  editBusiness(business) {
    this.modalService.show(BusinessPopupComponent, {
      initialState: {
        title: 'edit-business',
        type: 'edit-business',
        business: business,
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  deleteBusinessPopup(id) {
    this.modalService.show(DeletePopupComponent, {
      initialState: {
        title: 'delete-business',
        text: 'delete-business-text',
        id: id,
        onButtonClick: this.deleteBusiness.bind(this),
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  async deleteBusiness(id): Promise<void> {
    console.log('delete business id:');
    console.log(id);
    return new Promise((resolve, reject) => {
      this.businessesService.deleteBusiness(id).subscribe(
        (response) => {
          console.log('response:');
          console.log(response);
          this.eventEmitterService.callAllBusinesses();
          resolve();
        },
        (error) => {
          console.log('error:');
          console.log(error);
          reject();
        },
      );
    });
  }
}
